import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const AssetAllocation = ({ assets }) => {
  const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground">{payload?.[0]?.name}</p>
          <p className="text-sm text-muted-foreground">
            ${payload?.[0]?.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <p className="text-xs text-muted-foreground">
            {payload?.[0]?.payload?.percentage?.toFixed(2)}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl md:text-2xl font-bold text-foreground">Asset Allocation</h3>
        <div className="bg-muted rounded-full px-3 py-1.5">
          <span className="text-xs md:text-sm font-medium text-muted-foreground">Portfolio Distribution</span>
        </div>
      </div>
      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Asset Allocation Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={assets}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius="80%"
              fill="#8884d8"
              dataKey="value"
              label={({ name, percentage }) => `${name} ${percentage?.toFixed(1)}%`}
            >
              {assets?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              iconType="circle"
              wrapperStyle={{ fontSize: '14px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {assets?.map((asset, index) => (
          <div key={asset?.name} className="flex items-center gap-2 p-3 bg-muted rounded-lg">
            <div 
              className="w-3 h-3 rounded-full flex-shrink-0" 
              style={{ backgroundColor: COLORS?.[index % COLORS?.length] }}
            />
            <div className="min-w-0">
              <p className="text-xs md:text-sm font-medium text-foreground truncate">{asset?.name}</p>
              <p className="text-xs text-muted-foreground">{asset?.percentage?.toFixed(2)}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssetAllocation;